import { CanActivateFn, Router } from '@angular/router';
import { ErrorType } from '../enums/enums.enum';
import { CustomErrorHandler } from '../services/error-handler.service';
import { inject } from '@angular/core';

export const MedioPagoIdGuard: CanActivateFn = (route, state) => {
  const errorHandler = inject(CustomErrorHandler);
  const router = inject(Router);

  const id = route.queryParamMap.get('id') || '';
  const status = route.queryParamMap.get('status') || '';
  
  
  /* @TODO: custom backend validator for id */
  if (id.length >= 10) {
    return true;
  } else {
    /* If there is a status param yet no id param, redirect to blank-iframe */
    if (status !== '') {
      return router.createUrlTree(['/blank-iframe'], {
        queryParams: route.queryParams
      });
    } else {
      /* Invalid id and no status param */
      const error = {
        status: 401,
        error: {
          user_message_title: 'No tienes autorización'
        }
      };
      errorHandler.reportError(error, ErrorType.UNKNOWN);
      
      return false;
    }
  }
};
